import { linkToTeacherDashboard } from "../../links";

export function linkToSettings() {
  return `${linkToTeacherDashboard()}/settings`;
}

// TODO: can the settings page be refactored to take in a base link
// similar to create/edit assignment journeys
export function linkToPersonalInformation() {
  return `${linkToSettings()}/personal-information`;
}

export function linkToChangeEmail() {
  return `${linkToPersonalInformation()}/change-email`;
}

export function linkToPasswordUpdate() {
  return `${linkToSettings()}/password`;
}

export function linkToNotificationsPreferences() {
  return `${linkToSettings()}/notifications`;
}
